<script setup>
const route = useRoute()
const isQuery = computed(() => Boolean(route.query.pid))
</script>

<template>
  <div>
    <PageTop v-if="!isQuery" />
    <PagePoint
      v-if="isQuery"
      :pid="route.query.pid"
    />
  </div>
</template>
